<template>
  <div>
    <div class="d-inline-flex mb-4">
      <div class="form-check mr-3" v-if="effect_fields.length">
        <input
          class="form-check-input select-all mt-0"
          type="checkbox"
          v-model="selectAll"
        />
      </div>
      <h4 class="mr-3 mb-0">
        Effects
      </h4>
      <div class="d-flex align-items-center">
        <span class="cursor-pointer">
          <img
            src="~@/assets/addplus_icon.svg"
            width="20"
            class="heading-icon"
            @click="showAddNewEffectModal"
          />
        </span>
        <span
          v-if="effect_fields.length"
          class="cursor-pointer ml-3"
          @click="deleteAllEffects()"
        >
          <i class="fa fa-trash"></i>
        </span>
      </div>
    </div>
    <div v-for="(effectitem, index) in effect_fields" :key="index" class="mb-3">
      <div class="fields-wrapper is-divider is-multi-node">
        <div class="form-check select-single">
          <input
            class="form-check-input"
            type="checkbox"
            @change="checkSingleSelect"
            v-model="effectitem.effect.selectSingle"
          />
        </div>
        <div
          class="action-buttons"
          v-if="!effectitem.effect.isCopied || effectitem.effect.selectSingle"
        >
          <span
            v-if="!effectitem.effect.isCopied"
            class="action-item "
            @click="copyEffect(index, effectitem)"
          >
            <i class="fa fa-copy"></i>
          </span>
          <span
            v-if="effectitem.effect.selectSingle"
            class="action-item"
            @click="deleteEffect(index, effectitem)"
          >
            <i class="fa fa-trash"></i>
          </span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label for="effect_selector" class="col-sm-3 col-form-label">
                Effect Selector
              </label>
              <div class="col-sm-9">
                <select id="effect_selector"
                  v-model="effectitem.effect.name"
                  @change="changeSelectedEffectItem(index, effectitem.effect.name)"
                  class="custom-select"
                >
                  <option  v-for="(effectSelector, index) in effects"
                    :key="index"
                    class="custom-select"
                    :value="effectSelector.name"
                  >
                  {{effectSelector.name}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Effect Type
              </label>
              <div class="col-sm-9">
                <select
                  placeholder="Select Effect Type"
                  class="custom-select"
                  v-model="effectitem.effect.effectType"
                >
                  <option value="2D">2D</option>
                  <option value="3D">3D</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-3 col-form-label">
                Start Time
              </label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="start_time" v-model="effectitem.effect.startTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                End Time
              </label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="end_time" v-model="effectitem.effect.endTime" @change="setDuration(index)">
              </div>
            </div>
            <div class="row form-group align-items-center">
            <label class="col-sm-3 col-form-label">
              Loop
            </label>
            <div class="col-sm-9">
              <div class="d-flex align-items-center">
                <div class="input-switch label-right p-0">
                  <input type="checkbox" v-model="effectitem.effect.loop" :id="effectitem.effect.id">
                  <label :for="effectitem.effect.id" class="label-left">
                    <span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Position of origin (meters)
              </label>
              <div class="col-sm-9">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="text" class="form-control" id="position_of_origin_x" v-model="effectitem.effect.position[0]">
                  <span class="p-2">y</span>
                  <input type="text" class="form-control" id="position_of_origin_y" v-model="effectitem.effect.position[1]">
                  <span class="p-2">z</span>
                  <input type="text" class="form-control" id="position_of_origin_z" v-model="effectitem.effect.position[2]">

                </div>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Rotation of origin (meters)
              </label>
              <div class="col-sm-9">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="text" class="form-control" id="rotation_of_origin_x" v-model="effectitem.effect.rotation[0]">
                  <span class="p-2">y</span>
                  <input type="text" class="form-control" id="rotation_of_origin_y" v-model="effectitem.effect.rotation[1]">
                  <span class="p-2">z</span>
                  <input type="text" class="form-control" id="rotation_of_origin_z" v-model="effectitem.effect.rotation[2]">

                </div>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Scale of origin (meters)
              </label>
              <div class="col-sm-9">
                <div class="d-flex align-items-center">
                  <span class="p-2">x</span>
                  <input type="text" class="form-control" id="scale_of_origin_x" v-model="effectitem.effect.scale[0]">
                  <span class="p-2">y</span>
                  <input type="text" class="form-control" id="scale_of_origin_y" v-model="effectitem.effect.scale[1]">
                  <span class="p-2">z</span>
                  <input type="text" class="form-control" id="scale_of_origin_z" v-model="effectitem.effect.scale[2]">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="row form-group mt-4">
      <div class="col-12 text-center">
        <button class="btn btn-primary mr-3" v-if="effect_fields.length" @click="saveToDB()">Save</button>
      </div>
    </div> -->

    <template v-if="showModal">
      <div id="character-modal" class="modal" tabindex="-1" role="dialog" data-backdrop="static"
            data-keyboard="false">
        <div class="modal-dialog modal-lg" role="document">

          <div class="modal-content">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>

            <div class="modal-header">
              <h4 class="text-center font-size-20">
                Effect Modal
              </h4>
              <div class="clearfix"></div>
            </div>

            <div class="modal-body">
              <div class="form-row">
                <div class="form-group col-12">
                  <p class="font-weight-bold">Select Effect</p>
                  <div class="models-wrapper">
                    <div v-for="(effect,index) in effects"
                        :key="index"
                        class="model-item"
                        :class="{'active': activeChar === effect.name }"
                    >
                      <img v-if="effect.hasOwnProperty('image')" :src="effect.image.imageURL" class="img-fluid" />
                      <p>{{ effect.name }}</p>
                      <div class="col-1">
                        <button @click="updatedSelectedEffect(index)"
                                class="btn btn-primary" id="select_audio_duration_e">Select
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

import {mapActions, mapState} from 'vuex'
import {Howl} from 'howler'
import $ from 'jquery'
import {uuid} from 'vue-uuid'
import {db} from '../../../../../firebaseDB'
import { duration } from 'moment'

export default {
  components: {},
  data () {
    return {
      selectAll: false,
      effect_fields: [],
      currentLoop: 0,
      currentSelectedSound: '',
      activeSound: '',
      howl: '',
      selectedSoundStart: 0,
      selectedSoundEnd: '',
      sampleSound: '',
      showModal: false,
      activeChar: 'Select Effect',
      isCopied: false,
      selectSingle: false,
      currentIndex: null,
      charList: [],
      playSelectedOne: '',
      activeChar: {}
    }
  },
  created () {
    this.listEffects()
  },

  methods: {
    ...mapActions([
      'listEffects'
    ]),
    addNewEffect (index) {
      const lastIndex = this.effect_fields.length ? this.effect_fields.length - 1 : 0
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      duration = duration <= 5 ? duration : 5;
      let start = 0
      let end = 0
      if (duration >= 2 && this.timeLineCursor >= this.activeChar.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(duration)).toFixed(2)
        duration = parseFloat(duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime + 5).toFixed(2) : parseFloat(this.activeChar.startTime) + 5
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeChar.startTime)
        duration = 5
      }
      let position = []
      position.push(this.effects[index].hasOwnProperty('positionOfOrigin') ? this.effects[index].positionOfOrigin.X : 0)
      position.push(this.effects[index].hasOwnProperty('positionOfOrigin') ? this.effects[index].positionOfOrigin.Y : 0)
      position.push(this.effects[index].hasOwnProperty('positionOfOrigin') ? this.effects[index].positionOfOrigin.Z : 0)
      let rotation = []
      rotation.push(this.effects[index].hasOwnProperty('rotationOfOrigin') ? this.effects[index].rotationOfOrigin.X : 0)
      rotation.push(this.effects[index].hasOwnProperty('rotationOfOrigin') ? this.effects[index].rotationOfOrigin.Y : 0)
      rotation.push(this.effects[index].hasOwnProperty('rotationOfOrigin') ? this.effects[index].rotationOfOrigin.Z : 0)
      let scale = []
      scale.push(this.effects[index].hasOwnProperty('scaleOfOrigin') ? this.effects[index].scaleOfOrigin.X : 0)
      scale.push(this.effects[index].hasOwnProperty('scaleOfOrigin') ? this.effects[index].scaleOfOrigin.Y : 0)
      scale.push(this.effects[index].hasOwnProperty('scaleOfOrigin') ? this.effects[index].scaleOfOrigin.Z : 0)
      let id = uuid.v1()
      this.effect_fields.push({
        elementType: 'Effect',
        id: id,
        effect: {
          intId: index,
          id: id,
          name: this.effects[index].name,
          effectType: this.effects[index].effectType,
          iOSAseetBundle: this.effects[index].hasOwnProperty('asset_bundle') && this.effects[index].asset_bundle.hasOwnProperty('iOS') ? this.effects[index].asset_bundle.iOS.fileURL : '',
          AndroidAssetBundle: this.effects[index].hasOwnProperty('asset_bundle') && this.effects[index].asset_bundle.hasOwnProperty('Android') ? this.effects[index].asset_bundle.Android.fileURL : '',
          webglAssetBundle: this.effects[index].hasOwnProperty('asset_bundle') && this.effects[index].asset_bundle.hasOwnProperty('WebGL') ? this.effects[index].asset_bundle.WebGL.fileURL : '',
          position: position,
          rotation: rotation,
          scale: scale,
          startTime: start,
          endTime: end,
          loop: this.effects[index].hasOwnProperty('loop') && this.effects[index].loop === 0 ? false : !!(this.effects[index].loop === 1 || this.effects[index].loop === true),
          identifiableSurfaces: '',
          prefabName: this.effects[index].prefabName || this.effects[index].name,
          isCopied: false,
          selectSingle: false,
          duration: duration
        }
      })
      this.reflext()
    },
    nextElement (time) {
      let duration = 5
      let min = 99999999
      let element = this.effect_fields.filter((el) => {
        return (parseFloat(el.effect.startTime) <= time && parseFloat(el.effect.endTime) > time)
      })
      if (element.length) {
        return 0;
      }
      element = this.effect_fields.forEach((el) => {
        if (parseFloat(el.effect.startTime) >= time && parseFloat(el.effect.startTime) <= min) {
          duration = parseFloat(el.effect.startTime) - time
          min = parseFloat(el.effect.startTime) 
        }
      })
      return duration;
    },
    copyEffect (index, item) {
      let duration = this.nextElement(this.timeLineCursor.toFixed(2));
      let start = 0
      let end = 0
      if (duration >= item.effect.duration && this.timeLineCursor >= this.activeChar.startTime) {
        start = this.timeLineCursor.toFixed(2)
        end = (parseFloat(this.timeLineCursor) + parseFloat(item.effect.duration)).toFixed(2)
        duration = parseFloat(item.effect.duration).toFixed(2)
      } else {
        end = this.lastElementEndTime ? (this.lastElementEndTime +  parseFloat(item.effect.duration)).toFixed(2) : parseFloat(this.activeChar.startTime) + parseFloat(item.effect.duration)
        start = this.lastElementEndTime ? this.lastElementEndTime.toFixed(2) : parseFloat(this.activeChar.startTime)
        duration = parseFloat(item.effect.duration).toFixed(2)
      }
      this.effect_fields[index].effect.isCopied = !this.effect_fields[index].effect.isCopied
      let id = uuid.v1()
      this.effect_fields.push({
        elementType: 'Effect',
        id: id,
        effect: {
          intId: item.effect.intId,
          id: id,
          name: item.effect.name,
          effectType: item.effect.effectType,
          iOSAseetBundle: item.effect.iOSAseetBundle,
          AndroidAssetBundle: item.effect.AndroidAssetBundle,
          webglAssetBundle: item.effect.webglAssetBundle,
          position: item.effect.position,
          rotation: item.effect.rotation,
          scale: item.effect.scale,
          startTime: start,
          endTime: end,
          loop: item.effect.loop === 0 ? false : !!(item.effect.loop === 1 || item.effect.loop === true),
          identifiableSurfaces: item.effect.identifiableSurfaces,
          prefabName: item.effect.prefabName,
          isCopied: false,
          selectSingle: false,
          duration: duration
        }
      })
      this.reflext()
    },
    reflext () {
      let newChar =
      this.characters &&
        this.characters.map(char =>
          char.objectId === this.activeChar.objectId
            ? {
              ...char,
              characterElements: 
              char.characterElements ? [
                ...char.characterElements.filter(
                  el => !el.hasOwnProperty('effect')
                ),
                ...this.effect_fields
              ] :  
              [ ...this.effect_fields ]
            }
            : {...char}
        )
      this.$store.dispatch('updateCharacters', newChar)
    },
    deleteEffect (key, item) {
      var idx = this.effect_fields.indexOf(item)
      if (idx > -1) {
        this.effect_fields.splice(idx, 1)
      }
      this.reflext()
      this.$root.$emit('removeSubnode', item.id, 'Effect', this.activeChar.objectId)
    },
    changeSelectedEffectItem (index, name) {
      for (const key in this.effects) {
        if (this.effects[key].name === name) {
          let startTime = 0
          let endTime = 0
          let position = []
          position.push(this.effects[key].hasOwnProperty('positionOfOrigin') ? this.effects[key].positionOfOrigin.X : 0)
          position.push(this.effects[key].hasOwnProperty('positionOfOrigin') ? this.effects[key].positionOfOrigin.Y : 0)
          position.push(this.effects[key].hasOwnProperty('positionOfOrigin') ? this.effects[key].positionOfOrigin.Z : 0)
          let rotation = []
          rotation.push(this.effects[key].hasOwnProperty('rotationOfOrigin') ? this.effects[key].rotationOfOrigin.X : 0)
          rotation.push(this.effects[key].hasOwnProperty('rotationOfOrigin') ? this.effects[key].rotationOfOrigin.Y : 0)
          rotation.push(this.effects[key].hasOwnProperty('rotationOfOrigin') ? this.effects[key].rotationOfOrigin.Z : 0)
          let scale = []
          scale.push(this.effects[key].hasOwnProperty('scaleOfOrigin') ? this.effects[key].scaleOfOrigin.X : 0)
          scale.push(this.effects[key].hasOwnProperty('scaleOfOrigin') ? this.effects[key].scaleOfOrigin.Y : 0)
          scale.push(this.effects[key].hasOwnProperty('scaleOfOrigin') ? this.effects[key].scaleOfOrigin.Z : 0)
          this.effect_fields[index].effect.intId = key
          this.effect_fields[index].effect.id = uuid.v1()
          this.effect_fields[index].effect.name = this.effects[key].name
          this.effect_fields[index].effect.effectType = this.effects[key].effectType
          this.effect_fields[index].effect.iOSAseetBundle = this.effects[key].hasOwnProperty('asset_bundle') && this.effects[key].asset_bundle.hasOwnProperty('iOS') ? this.effects[key].asset_bundle.iOS.fileURL : ''
          this.effect_fields[index].effect.AndroidAssetBundle = this.effects[key].hasOwnProperty('asset_bundle') && this.effects[key].asset_bundle.hasOwnProperty('Android') ? this.effects[key].asset_bundle.Android.fileURL : ''
          this.effect_fields[index].effect.webglAssetBundle = this.effects[key].hasOwnProperty('asset_bundle') && this.effects[key].asset_bundle.hasOwnProperty('WebGL') ? this.effects[key].asset_bundle.WebGL.fileURL : ''
          this.effect_fields[index].effect.position = position
          this.effect_fields[index].effect.rotation = rotation
          this.effect_fields[index].effect.scale = scale
          this.effect_fields[index].effect.startTime = startTime
          this.effect_fields[index].effect.endTime = endTime
          this.effect_fields[index].effect.loop = this.effects[key].loop
          this.effect_fields[index].effect.identifiableSurfaces = ''
          this.effect_fields[index].effect.prefabName = this.effects[key].prefabName || this.effects[key].name,
          this.effect_fields[index].effect.isCopied = false
          this.effect_fields[index].effect.selectSingle = false
        }
      }
    },
    onEndEvent () {
      this.currentLoop += 1
      if (this.currentLoop < this.no_of_loops) {
        this.playSound()
      } else {
        this.currentLoop = 0
      }
    },
    updatedSelectedEffect (value) {
      this.currentSelectedSound = value
      this.closeModal()
      this.addNewEffect(value)
    },
    saveToDB () {
      let _this = this
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
      tRef.once('value').then(async snapshot => {
        let storyData = snapshot.val();
        let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
        .filter(n => n.key !== 'Start')
        .filter(n => n.category == 'Scene');
        let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
        let json = snapshot.val().json
        let characterElements = []
        for (const snapshotkey in json.mainStory.nodes[selectedNodePosition].nodeElements) {
          if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].hasOwnProperty('character') && json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.objectId == _this.currentIndex) {
            for (const innerKey in json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements) {
              if (json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey].elementType === 'Effect') {
                delete json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey]
              } else {
                characterElements.push(json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements[innerKey])
              }
            }
            const data = []
            _this.effect_fields.forEach((value, key) => {
              delete value.effect.isCopied
              delete value.effect.selectSingle
              characterElements.push({
                elementType: value.elementType,
                id: value.id,
                effect: {...value.effect}
              })
            })
            json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey].character.characterElements = characterElements
            let updates = {}
            updates[localStorage.getItem('storyId') + `/json`] = json
            db.ref('stories')
              .update(updates)
              .then(snapshot => {
                _this.showSuccessToast()
              })
              .catch(e => {
                _this.showErrorToast()
              })
            this.$parent.activeComponent = 'effects'
          }
        }
      })
    },
    showSuccessToast () {
      this.$toast('Effect inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Effect inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    showAddNewEffectModal: function () {
      this.showModal = true
      this.$nextTick(() => {
        $('#character-modal').modal('show')
      })
    },
    closeModal () {
      $('.modal').modal('hide')
      this.showModal = false
    },
    deleteAllEffects () {
      this.selectAll = false
      this.effect_fields = this.effect_fields.filter(value => {
        return !value.effect.selectSingle
      })
      this.reflext()
    },
    checkSingleSelect () {
      this.effect_fields.forEach(value => {
        if (value.effect.selectSingle) {
          this.isSelected = true
        }
      })
    },
    changeModelInspector () {
      let hasEffect = false
      for (const key in this.charList) {
        if (this.charList[key].character.objectId == this.currentIndex) {
          this.effect_fields = []
          console.log(this.charList[key].character.characterElements)
          for (const valueKey in this.charList[key].character.characterElements) {
            if (this.charList[key].character.characterElements[valueKey].elementType === 'Effect') {
              hasEffect = true
              this.effect_fields.push(this.charList[key].character.characterElements[valueKey])
              this.currentIndex = this.charList[key].character.objectId
            }
          }
        }
      }
    },
    setDuration (index) {
      this.effect_fields[index].effect.duration = this.effect_fields[index].effect.endTime - this.effect_fields[index].effect.startTime
    },
    changeSelectedObject () {
      this.effect_fields  = []
      this.characters.map((val, index) => {
        if (val.active) {
          this.activeChar = val
          if (val.characterElements) {
            val.characterElements.forEach(element => {
              if (element.elementType === 'Effect') {
                element.effect.isCopied = false
                element.effect.selectSingle = false
                this.effect_fields.push(element)
              }
            });
          }
        }
      })
    }
  },
  mounted () {
    // let _this = this
    // let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
    // let selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'));
    // tRef.on('value', snapshot => {
    //   let storyData = snapshot.val();
    //     let nodeDataArray = ((storyData && storyData.diagram) ? storyData.diagram.nodeDataArray || [] : [])
    //     .filter(n => n.key !== 'Start')
    //     .filter(n => n.category == 'Scene');
    //     let selectedNodePosition = nodeDataArray.findIndex(n => n.key == selectedLogic.key);
    //   this.charList = []
    //   if (!snapshot.val().json.mainStory.nodes[selectedNodePosition].nodeElements) {
    //     _this.addNewEffect()
    //   } else {
    //     let hasEffect = false
    //     snapshot.val().json.mainStory.nodes[selectedNodePosition].nodeElements.forEach(value => {
    //       if (value.elementType === 'Character') {
    //         this.charList.push(value)
    //         if (!_this.currentIndex) {
    //           for (const valueKey in value.character.characterElements) {
    //             if (value.character.characterElements[valueKey].elementType === 'Effect') {
    //               hasEffect = true
    //               _this.currentIndex = value.character.objectId
    //               _this.effect_fields.push(value.character.characterElements[valueKey])
    //               _this.effect_fields[_this.effect_fields.length - 1].effect.loop = _this.effect_fields[_this.effect_fields.length - 1].effect.loop === 0 ? false : !!(_this.effect_fields[_this.effect_fields.length - 1].effect.loop === 1 || _this.effect_fields[_this.effect_fields.length - 1].effect.loop === true)
    //             }
    //           }
    //         } else {
    //           if (_this.currentIndex === value.character.objectId) {
    //             _this.effect_fields = []
    //             for (const valueKey in value.character.characterElements) {
    //               if (value.character.characterElements[valueKey].elementType === 'Effect') {
    //                 hasEffect = true
    //                 _this.effect_fields.push(value.character.characterElements[valueKey])
    //               }
    //             }
    //           }
    //         }
    //       }
    //     })
    //   }
    //   _this.currentIndex = _this.charList[0].character.objectId
    //   if (this.effect_fields.length < 1) {
    //     this.showAddNewEffectModal()
    //   }
    // })

    this.effect_fields  = []
    this.characters.map((val, index) => {
      if (val.active) {
        this.activeChar = val
        if (val.characterElements) {
          val.characterElements.forEach(element => {
            if (element.elementType === 'Effect') {
              element.effect.isCopied = false
              element.effect.selectSingle = false
              this.effect_fields.push(element)
            }
          });
        }
      }
    })
  },
  watch: {
    selectAll: function (val) {
      this.isSelected = !!val
      if (this.effect_fields) {
        this.effect_fields.forEach(value => {
          value.effect.selectSingle = val
        })
      }
    },
    characters (val) {
      this.changeSelectedObject();
    },
  },
  computed: {
    lastElementEndTime () {
      let max = 0
      this.effect_fields.forEach((el) => {
        if (parseFloat(el.effect.endTime) >= max) {
          max = parseFloat(el.effect.endTime)
        }
      })
      return max;
    },
    ...mapState([
      'effects',
      'characters',
      'timeLineCursor'
    ]),
  }
}
</script>
<style>
.selectSound {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/character/effects.vue